<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import type {RouterTab} from "@/types/tabs";

const router = useRouter();
const route = useRoute();

const navigateTo = (routeName: string) => {
  router.push({ name: routeName });
};

const props = defineProps<{
  items: RouterTab[];
}>();

</script>

<template>
  <div class="flex items-center space-x-4 ">
    <a
      v-for="item in props.items"
      class="cursor-pointer"
      :class="route.name === item.routeName ? 'text-gpx_black-500 font-bold' : 'text-gpx_gray-700'"
      @click="navigateTo(item.routeName)"
      tabindex="0"
      @keydown.enter="navigateTo(item.routeName)"
      role="button"
      :aria-label="item.title"
    >
      {{item.title}}
    </a>
  </div>
</template>
